var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{class:{mini: _vm.size === 'mini'},attrs:{"show":_vm.showDismissibleAlert,"variant":_vm.infoType,"dismissible":""},on:{"dismissed":_vm.dismissAndSave}},[_vm._t("default"),_c('template',{slot:"dismiss"},[_c('icon',{attrs:{"name":"times"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }